import { token, account } from './stores.js'

const DEV_API_URL = 'http://localhost:8000/api'
const PROD_API_URL = 'https://cds.kermit.ovh/api'

const API_URL = PROD_API_URL

const endpointsMap = {
  ana: '/runner/ana',
  ana_custom: '/runner/customs-ana',
  forecast: '/runner/forecast',
  forecast_custom: '/runner/customs-forecast',
  runner: '/runner/rerun-'
}

function logout () {
    console.log('lougout')
    token.set('')
    account.set('')
}

function getHeaders() {
  let _token
  token.subscribe(v => _token = v)

  return new Headers({
    'Authorization': 'Bearer ' + _token
  })
}

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

function getPostHeaders () {
  let _token
  token.subscribe(v => _token = v)

  return new Headers({
    'Content-Type': 'application/json',    
    'Authorization': 'Bearer ' + _token
  })
}

export function login (username, password) {
  if (username === undefined || password === undefined) return new Promise((res, rej) => {
    throw 'empty_credentials'
  })
  if (username === '' || password === '') return new Promise((res, rej) => {
    throw 'empty_credentials'
  })

  let payload = new URLSearchParams();
  payload.append('username', username)
  payload.append('password', password)

  return fetch(API_URL + '/login/access-token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: payload
  }).then(response => {
    if (response.status === 200) {
      account.set(username)
      // logo.set('/images/' + username + '.jpg')
      response.json().then(data => {
        account.set(parseJwt(data.access_token).user);
	    token.set(data.access_token)
      })
    } else {
      throw 'bad_credentials'
    }
  })
}

export function getConfigsWithStatuses (date) {
  return fetch(API_URL + '/delivery-configs-with-statuses/' + date, {
    method: 'GET',
    headers: getHeaders()
  }).then(response => {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 403) {
      logout()
    } else {
      throw 'get_configs_error'
    }
  })
}

export function getCustomConfigsWithStatuses (date) {
  return fetch(API_URL + '/custom-delivery-configs-with-statuses/' + date, {
    method: 'GET',
    headers: getHeaders()
  }).then(response => {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 403) {
      logout()
    } else {
      throw 'get_configs_error'
    }
  })
}

export function getDeliveriesStatuses (date) {
  return fetch(API_URL + '/records-v2/statuses/' + date, {
    method: 'GET',
    headers: getHeaders()
  }).then(response => {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 403) {
      logout()
    } else {
      throw 'get_statuses_error'
    }
  })
}

export function rerunConfig (config, date, mode) {
  const URL = API_URL + endpointsMap[config.metadatas.kind]

  let runDate
  if (mode === '12Z') runDate = date + 'T12:00:00'
  else runDate = date + 'T00:00:00'
  
  const payload = {
    only_names: [config.metadatas.name],
    run_date: runDate
  }

  return fetch(URL, {
    method: 'POST',
    headers: getPostHeaders(),
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response.json()
    }
  })
}


export function callRunner (runnerName) {
  const URL = API_URL + endpointsMap['runner'] + runnerName
  
  return fetch(URL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response.json()
    }
  })
}



export function getPoints (fileName) {
  return fetch(API_URL + '/points/' + fileName, {
    method: 'GET',
    headers: getHeaders()
  }).then(response => {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 403) {
      logout()
    } else {
      throw 'get_points_error'
    }
  })
}
